module.exports = __webpack_public_path__ + "img/600.4505a986.jpg";